(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-customer-viewing"] && !Shopify.designMode) return;
  try {
    class CustomerViewingComponent extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-customer-viewing-number]');
      if (!numberElem) return;

      const numbersViewerStr = this.dataset.customerView;
      if (!numbersViewerStr) return;

      const numbersViewerList = numbersViewerStr
        .split(',')
        .map(item => parseInt(item.trim(), 10))
        .filter(num => !isNaN(num) && num > 0);

      if (!numbersViewerList.length) return;

      let timeViewer = parseInt(this.dataset.customerViewTime, 10);
      if (isNaN(timeViewer) || timeViewer < 1) timeViewer = 5;
      timeViewer = timeViewer * 1000;

      const updateNumber = () => {
        const randomIdx = Math.floor(Math.random() * numbersViewerList.length);
        const value = numbersViewerList[randomIdx];
        numberElem.textContent = value;
      };

      updateNumber();

      this.timer = setInterval(updateNumber, timeViewer);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('customer-viewing-component')) {
      customElements.define('customer-viewing-component', CustomerViewingComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-positive-vibes"] && !Shopify.designMode) return;
  try {
    class PositiveVibesComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const parent = this.querySelector('.text-vibes');
      const children = this.querySelectorAll('.text-vibes--child');
      let currentIndex = 0;

      if (children.length > 1) {
        const newDiv = document.createElement("div");
        newDiv.classList.add("text-vibes--child");
        newDiv.innerHTML = children[0].innerHTML;
        parent.appendChild(newDiv);

        const childrenTexts = parent.querySelectorAll('.text-vibes--child');
        setInterval(() => {
          if (parent) {
            parent.classList.add('js-active');
          }
          const height = childrenTexts[currentIndex].offsetHeight;
          childrenTexts.forEach((child, index) => {
            parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: all .5s ease;`;
            if (currentIndex == 0) {
              parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: none;`;
            }
          });
          currentIndex = (currentIndex + 1) % childrenTexts.length;
          this.heightPositive();
        }, 3000);
      }
    }

    heightPositive() {
      const parent = this.querySelector('.text-vibes');
      const childrenTexts = this.querySelectorAll('.text-vibes--child');

      let maxHeight = 0;
      childrenTexts.forEach(child => {
        maxHeight = Math.max(maxHeight, child.querySelector('p').offsetHeight);
      });

      this.style.minHeight = maxHeight + 'px';

      childrenTexts.forEach(child => {
        child.style.minHeight = `${maxHeight}px`;
      });
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('positive-vibes-component')) {
      customElements.define('positive-vibes-component', PositiveVibesComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-sold-in-last"] && !Shopify.designMode) return;
  try {
    class SoldInLastComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-sold-out-number]');
      const hoursElem = this.querySelector('[data-sold-out-hours]');

      let numbersListStr = this.dataset.items || this.getAttribute('data-items') || "3,5,6,7,8,10,12,15";
      let hoursListStr = this.dataset.hours || this.getAttribute('data-hours') || "10,15,16,17,18,20,25,35";

      const numbersList = numbersListStr.split(',').map(item => item.trim()).filter(item => !!item);
      const hoursList = hoursListStr.split(',').map(item => item.trim()).filter(item => !!item);

      const numberIdx = Math.floor(Math.random() * numbersList.length);
      const hourIdx = Math.floor(Math.random() * hoursList.length);

      if (numberElem && numbersList.length > 0) {
        numberElem.textContent = numbersList[numberIdx];
      }
      if (hoursElem && hoursList.length > 0) {
        hoursElem.textContent = hoursList[hourIdx];
      }
      this.classList.remove('loading');
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('sold-in-last-component')) {
      customElements.define('sold-in-last-component', SoldInLastComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_social-share-button"] && !Shopify.designMode) return;
  try {
    class ShareButtonProduct extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        content: this.querySelector('.share-button__product'),
        copyButton: this.querySelector('.button-copy'),
      };

      if (this.elements.shareButton) {
        this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
      }
      if (this.elements.copyButton) {
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    toggleDetails(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();
      if (!this.elements.urlInput) return;

      const url = this.elements.urlInput.getAttribute('data-url');

      this.setProductInfoTop(this.getProductInfoPosition());

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
    }

    copyToClipboard(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();

      if (!this.elements.urlInput || this.elements.urlInput.classList.contains('is-copy')) return;

      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.setAttribute('aria-hidden', false);
        }
        this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
        this.elements.urlInput.classList.add('is-copy');

        setTimeout(() => {
          if (this.elements.successMessage) {
            this.elements.successMessage.setAttribute('aria-hidden', true);
          }
        }, 6000);
      });
    }

    closeDetails(event) {
      event?.preventDefault && event.preventDefault();
      if (!this.elements.urlInput) return;
      const url = this.elements.urlInput.getAttribute('data-url');

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
      this.setProductInfoTop(0);
    }

    getProductInfoPosition() {
      const stickyElement = document.querySelector('.productView-details');
      if (!stickyElement || !stickyElement.parentNode) return 0;

      const stickyRect = stickyElement.getBoundingClientRect();
      const parentRect = stickyElement.parentNode.getBoundingClientRect();

      const topOffset = stickyRect.top - parentRect.top;
      return topOffset;
    }

    setProductInfoTop(top) {
      const productDetails = document.querySelector('.productView-details');
      if (productDetails && productDetails.style) {
        productDetails.style.setProperty('--sticky-top', top + 'px');
      }
    }
  }

  if (!customElements.get('share-button-product')) {
    customElements.define('share-button-product', ShareButtonProduct);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    class EmailSignup extends HTMLElement {
    constructor() {
      super();
      this._handleOutsideClick = this._handleOutsideClick.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('[id^="EmailSignup-"]');
      this.checkbox = this.form?.querySelector('[id^="agree_condition-"]');
      this.submitButton = this.form?.querySelector("button[id^='EmailSignup-submit-']");
      this.subscriptionForm = this.querySelector('.subscription-form');
      this.emailForm = this.querySelector('.email-signup__form');
      this.promoBtn = this.querySelector('.promo-btn');
      this.openNewsletterPopupButton = this.querySelector('.open-newsletter-popup-button');
      // this.backBtn = this.emailForm.querySelector('.back-btn');

      this.initAgreeCondition();
      this.initPromoToggle();
      this.openNewsletterPopup();

      if (window.location.search.includes('contact_posted=true')) {
        this.showEmailForm(true);
      }
    }

    initAgreeCondition() {
      if (!this.checkbox || !this.submitButton) return;

      this.submitButton.disabled = true;

      this.checkbox.addEventListener('change', () => {
        this.submitButton.disabled = !this.checkbox.checked;
      });

      this.form.addEventListener('submit', (e) => {
        if (!this.checkbox.checked) {
          e.preventDefault();
          alert('Please agree to the terms and conditions before submitting.');
        }
      });
    }

    initPromoToggle() {
      if (!this.subscriptionForm || !this.emailForm || !this.promoBtn) return;

      this.emailForm.style.display = 'none';

      this.promoBtn.addEventListener('click', () => this.showEmailForm());
      // this.backBtn?.addEventListener('click', () => this.showSubscriptionForm());
    }

    openNewsletterPopup() {
      if (!this.openNewsletterPopupButton) return;
      this.openNewsletterPopupButton.addEventListener('click', (e) => {
        e.preventDefault();
        const popup = document.querySelector('.promotionPopup');
        if (popup) popup.setAttribute('open', '');
        const content = document.querySelector('.promotionPopup .popup__inner');
        Motion.timeline([
          [content, { opacity: [0, 1], transform: ['translate(-50%, -40%)', 'translate(-50%, -50%)'] }, { duration: 0.3, at: '-0.15' }]
        ]).finished;
      });
    }

    async showEmailForm(skipHideAnim = false) {
      if (!skipHideAnim) await this._animateHide(this.subscriptionForm);
      this.subscriptionForm.style.display = 'none';
      this.emailForm.style.display = '';
      await this._animateShow(this.emailForm);

      document.addEventListener('click', this._handleOutsideClick);
    }

    async showSubscriptionForm() {
      await this._animateHide(this.emailForm);
      this.emailForm.style.display = 'none';
      this.subscriptionForm.style.display = '';
      await this._animateShow(this.subscriptionForm);

      document.removeEventListener('click', this._handleOutsideClick);
    }

    _handleOutsideClick(e) {
      if (!this.contains(e.target)) {
        this.showSubscriptionForm();
      }
    }

    async _animateShow(element) {
      element.style.overflow = 'hidden';
      await Motion.timeline([
        [
          element,
          { height: ['0px', `${element.scrollHeight}px`] },
          { duration: 0.15, easing: 'cubic-bezier(0.7, 0, 0.3, 1)' },
        ],
        [
          element,
          { opacity: [0, 1], transform: ['translateX(-1rem)', 'translateX(0)'] },
          { duration: 0.15, at: '-0.1' },
        ],
      ]).finished;
      element.style.height = 'auto';
      element.style.overflow = 'visible';
    }

    async _animateHide(element) {
      element.style.overflow = 'hidden';
      await Motion.timeline([
        [element, { opacity: 0, transform: ['translateX(0)', 'translateX(1rem)'] }, { duration: 0.15 }],
        [
          element,
          { height: [`${element.clientHeight}px`, '0px'] },
          { duration: 0.15, at: '<', easing: 'cubic-bezier(0.7, 0, 0.3, 1)' },
        ],
      ]).finished;
      element.style.height = 'auto';
      element.style.overflow = 'visible';
    }
  }
  if (!customElements.get('email-signup')) customElements.define('email-signup', EmailSignup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["store-locator"] && !Shopify.designMode) return;
  try {
    (function() {
    var root = document.querySelector('.storeLocator');
    if (!root) return;

    var items = root.querySelectorAll('.storeLocator__item');
    var mapEl = root.querySelector('#map');
    if (!mapEl || !items.length) return;

    function setActive(item) {
      items.forEach(function(i) { i.classList.remove('active'); });
      item.classList.add('active');
    }

    function renderMapFrom(item) {
      var html = item.getAttribute('data-map') || '';
      mapEl.classList.add('is-loading');
      mapEl.innerHTML = html;

      setTimeout(function() {
        mapEl.classList.remove('is-loading');
      }, 500);
    }

    items.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        setActive(item);
        renderMapFrom(item);
      });
    });

    // Initialize with first item
    var first = items[0];
    if (first) {
      setActive(first);
      renderMapFrom(first);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
